import { graphql } from '@guuru/graphql-common/gql';

export default graphql(`
  query GetChatMessagesStatus($chatId: ID!) {
    chat(id: $chatId) {
      id
      status
    }
  }
`);
